import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
export function HeroSection() {
  return <section className="relative min-h-screen flex items-center justify-center overflow-hidden" data-id="element-207">
      {/* Background Image */}
      <div className="absolute inset-0 bg-cover bg-center bg-no-repeat" style={{
      backgroundImage: 'url(https://cdn.magicpatterns.com/uploads/hbtwzQxcScFnYgQGci8uZW/pcs_hero.png)'
    }} data-id="element-208" />

      {/* Dark Overlay */}
      <div className="absolute inset-0 bg-black/65" data-id="element-209" />

      {/* Subtle gradient overlay for depth */}
      <div className="absolute inset-0 bg-gradient-to-t from-[#0A0A0A] via-transparent to-[#0A0A0A]/40" data-id="element-210" />

      {/* Grid pattern */}
      <div className="absolute inset-0 bg-grid-pattern opacity-[0.08] pointer-events-none" data-id="element-211" />

      {/* Content */}
      <div className="relative z-10 max-w-5xl mx-auto px-6 md:px-12 pt-24 pb-16 flex flex-col items-center text-center" data-id="element-212">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.1
      }} className="inline-flex items-center gap-2 px-3 py-1 rounded-full border border-blue-500/30 bg-blue-500/10 backdrop-blur-sm mb-8" data-id="element-213">
          <span className="w-2 h-2 rounded-full bg-blue-500 animate-pulse" data-id="element-214" />
          <span className="text-xs font-medium text-blue-400 uppercase tracking-widest" data-id="element-215">
            Stop selling sites. Start selling digital assets.
          </span>
        </motion.div>

        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.2
      }} className="font-display text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bold tracking-tight text-white leading-[1.1] mb-6 max-w-[20ch] drop-shadow-lg" data-id="element-216">
          Your Digital Presence Should Command Authority, Not Just Exist.
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.3
      }} className="text-lg md:text-xl text-neutral-300 max-w-2xl mb-10 leading-relaxed drop-shadow-md" data-id="element-217">
          PCS fuses high-performance web architecture with premium content
          strategy to build digital assets that generate revenue, not just
          traffic.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.4
      }} className="flex flex-col sm:flex-row items-center gap-4 w-full sm:w-auto" data-id="element-218">
          <a href="#contact" className="w-full sm:w-auto group flex items-center justify-center gap-2 bg-blue-600 hover:bg-blue-500 text-white px-8 py-4 rounded-sm font-medium transition-all shadow-lg shadow-blue-600/20" data-id="element-219">
            Analyze My Digital Presence
            <ArrowRight size={18} className="group-hover:translate-x-1 transition-transform" data-id="element-220" />
          </a>
          <a href="https://wa.link/dis8bj" target="_blank" rel="noopener noreferrer" className="w-full sm:w-auto flex items-center justify-center bg-white/10 backdrop-blur-sm border border-white/20 hover:border-white/40 hover:bg-white/15 text-white px-8 py-4 rounded-sm font-medium transition-all" data-id="element-221">
            Book a Strategy Call
          </a>
        </motion.div>
      </div>
    </section>;
}